module.exports = __webpack_public_path__ + "images/FUSA_icons/013-calculator.d444bae4da01add57af904ac5294f3c2.svg";